import { sv } from "@dhx/ts-common/dom";
import { PointData } from "../types";

import spline from "../helpers/spline";
import Area from "./Area";

export default class SplineArea extends Area {
	protected _form(width: number, height: number, svg: any[], prev: PointData[]): object {
		const { fill, alpha, strokeWidth, color, id } = this.config;
		const className = this.config.css;

		let d = "";
		const first = this._points[0];
		if (prev) {
			d = `${spline([].concat(prev).reverse())} ${spline(this._points, true)} Z`;
		} else {
			d = `M${first[0]} ${height} V ${first[1]} ${spline(this._points)} V${height} H ${first[0]}`;
		}
		if (strokeWidth) {
			const line = spline(this._points);
			const splinePath = sv("path", {
				d: line,
				"stroke-width": strokeWidth,
				stroke: color,
				fill: "none",
				"stroke-linecap": "butt",
				class: className,
			});
			svg.push(splinePath);
		}
		const path = sv("path", {
			id: "seria" + id,
			d,
			class: className,
			fill,
			"fill-opacity": alpha,
			stroke: "none",
		});
		svg.push(path);
		return svg;
	}
}
